import { useState, useEffect } from 'react';
import YandexMetrikaInformer from '../../components/YandexMetrikaInformer/YandexMetrikaInformer';
import './footer.scss';

const Footer = () => {
    const [currentTime, setCurrentTime] = useState(new Date());

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentTime(new Date());
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    const formatDateTime = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getUTCHours()).padStart(2, '0');
        const minutes = String(date.getUTCMinutes()).padStart(2, '0');
        const seconds = String(date.getUTCSeconds()).padStart(2, '0');

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds} GMT`;
    };

    return (
        <footer className="footer">
            <div className="footer__content">
                <div className="footer__time">
                    {formatDateTime(currentTime)}
                </div>
                <YandexMetrikaInformer />
            </div>
        </footer>
    );
};

export default Footer;

